const rewards = (state, getters) => {
  for (var j = 0; j < state.reward_advertisers.length; j++) {
    if (state.reward_advertisers[j].id === getters.advertiser.id) {
      return state.reward_advertisers[j].rewards
    }
  }
  return []
}

const unArchivedRewards = (state, getters) => {
  for (var j = 0; j < state.reward_advertisers.length; j++) {
    if (state.reward_advertisers[j].id === getters.advertiser.id) {
      return state.reward_advertisers[j].rewards.filter(reward => !reward.is_archived)
    }
  }
  return []
}

const archivedRewards = (state, getters) => {
  for (var j = 0; j < state.reward_advertisers.length; j++) {
    if (state.reward_advertisers[j].id === getters.advertiser.id) {
      return state.reward_advertisers[j].rewards.filter(reward => reward.is_archived)
    }
  }
  return []
}

const hasEditingReward = (state) => {
  return state.reward_being_edited != null;
}

const reward_being_edited = (state) => {
  return state.reward_being_edited
}

const maxRewardId = (state, getters) => {
  var max = 0;
  for (var j = 0; j < state.reward_advertisers.length; j++) {
    if (state.reward_advertisers[j].id === getters.advertiser.id) {
      for (var i = 0; i < state.reward_advertisers[j].rewards.length; i++) { 
        if (state.reward_advertisers[j].rewards[i].id > max) {
          max = state.reward_advertisers[j].rewards[i].id
        }
      }
    }
  }
  return max
}

export default {
  rewards,
  unArchivedRewards,
  archivedRewards,
  hasEditingReward,
  reward_being_edited,
  maxRewardId
}